import React from "react";
import classNames from "classnames";
import "./badge.scss";

export type BadgeColor = "new" | "started" | "incomplete" | "application-received" | "processing" | "initial-approval" | "cleared-to-close" | "closed";

export interface BadgeProps {
  title: string;
  color?: BadgeColor;
  toUpperCase?: boolean;
  className?: string;
}

const Badge: React.FC<BadgeProps> = ({ title, color = "new", toUpperCase = true, className }) => {
  const badgeClassName = classNames("label-alt-medium-semibold", "badge", `badge--${color}`, className);

  return <span className={badgeClassName}>{toUpperCase ? title.toUpperCase() : title}</span>;
};

export default Badge;